import { FC } from "react"

import CustomLineChart from "../customLineChart";
import CustomButtonRight from "../customButtonRight";

import { StatisticsObjectType } from "./types";


const CaseVolume: FC<StatisticsObjectType> = ({ StatisticsObjectType, buttonShows }): JSX.Element => {
  return (
    <div className="row mt-3">
      <div className={` ${buttonShows ? "col-12 col-lg-9 mb-3 mb-lg-0 flex-fill d-flex" : "col"}`} style={{maxHeight:550}}>
        <CustomLineChart title="Case Volume" LineChartObject={StatisticsObjectType.case_volume} />
      </div>
      {buttonShows ? (
        <div className="col-12 col-lg-3 d-flex flex-column" style={{maxHeight:550}}>
          <CustomButtonRight StatisticsObjectType={StatisticsObjectType} />
        </div>
      ): null}
    </div>
  )
}

export default CaseVolume;
